import React from 'react'
import styles from './styles.css'
import Calendar from './calendar.svg'
import { format } from 'date-fns'

interface TimeProps {
  serviceDate: string
}

const Time: React.SFC<TimeProps> = ({ serviceDate }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>Charter date</div>
      <div className={styles.date}>
        <div className={styles.label}>{format(serviceDate, 'MMM d, YYYY, h:mm a')}</div>
        <div className={styles.icon}>
          <Calendar />
        </div>
      </div>
    </div>
  )
}

export default Time
